import {useFinesSecurityApi} from "./useFinesSecurityApi";
import qs from "qs";
import {useContext} from "react";
import {GlobalContext} from "../../../util/state/GlobalContextProvider";

export const useFinesActions = () => {
    const {GET, POST} = useFinesSecurityApi();

    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);

    async function getFinesList(filters: any, finesType: any) {
        let params = {
            reportNumber: filters.reportNumber ? filters.reportNumber : undefined,
            plate: filters.plate ? filters.plate : undefined,
            ra: filters.raNumber ? filters.raNumber : undefined,
            driver: filters.driver ? filters.driver : undefined,
            fineDateFrom: filters.fineDateFrom ? filters.fineDateFrom : undefined,
            fineDateTo: filters.fineDateTo ? filters.fineDateTo : undefined,
            invoiceDateFrom: filters.invoiceDateFrom ? filters.invoiceDateFrom : undefined,
            invoiceDateTo: filters.invoiceDateTo ? filters.invoiceDateTo : undefined,
            fineAmountFrom: filters.fineAmountFrom ? filters.fineAmountFrom : undefined,
            fineAmountTo: filters.fineAmountTo ? filters.fineAmountTo : undefined,
            // I query param attesi da BFF e microservizio sono penalityAmountFrom/To (cfr. openapi
            // fs-fines-payment e colonna penality_amount): il naming del form resta penaltyAmount*.
            penalityAmountFrom: filters.penaltyAmountFrom ? filters.penaltyAmountFrom : undefined,
            penalityAmountTo: filters.penaltyAmountTo ? filters.penaltyAmountTo : undefined,
            fineStatus: filters.fineStatus ? filters.fineStatus : undefined,
            offset: filters.offset,
            limit: filters.limit,
            sort: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined,
            finesType: finesType,
            tenant: filters.legalEntities ? filters.legalEntities : allLegalEntities,
            dealers: filters.dealers,
            customerId: filters.customerId ? filters.customerId : undefined
        };
        let data = await GET("fs/finesPayment", true, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return {
            totalElements: data.result?.total,
            content: data.result?.content
        };

    }

    async function getFinesDetail(id: any) {
        let params = {id: id ? id : undefined}
        let data = await GET("fs/finesPayment/single", true, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });

        return data?.result;
    }

    async function getFineStatus() {
        return await GET("fs/finesPayment/fineStatuses", true);
    }

    async function sendToInvoice(payload: any) {
        return await POST("fs/finesPayment/send-to-invoice", payload, true)
    }

    async function importFile(file: File, name: string, legalEntity: string, dealer: string, finesType: string) {
        let formData = new FormData();
        formData.append("datatrack", file);
        return await POST(`fs/finesPayment/datatrack/upload?filename=${name}&tenant=${legalEntity}&dealer=${dealer}&finesType=${finesType}`, formData, true, {headers: {"Content-Type": "multipart/form-data"}})
    }

    async function viewInvoice(invoiceNumber: number) {
        return await GET("fs/finesPayment/pdf/" + invoiceNumber, true);
    }

    return {
        getFinesList,
        getFinesDetail,
        getFineStatus,
        sendToInvoice,
        importFile,
        viewInvoice
    };
}